/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Plancreditspermonth3Inputs */

const en_plancreditspermonth3 = /** @type {(inputs: Plancreditspermonth3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} credits a month`)
};

const de_plancreditspermonth3 = /** @type {(inputs: Plancreditspermonth3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Credits im Monat`)
};

/**
* | output |
* | --- |
* | "{count} credits a month" |
*
* @param {Plancreditspermonth3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const plancreditspermonth3 = /** @type {((inputs: Plancreditspermonth3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plancreditspermonth3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plancreditspermonth3(inputs)
	return de_plancreditspermonth3(inputs)
});
export { plancreditspermonth3 as "planCreditsPerMonth" }